/**
 * Parses a string as a non-negative integer, clamping negatives and NaN to 0.
 * parseInt("-3") is truthy (= -3) so the common `parseInt(v) || 0` idiom
 * does not clamp negatives. This helper handles both.
 */
export const parseNonNegativeInt = (v: string): number => {
  const n = Number.parseInt(v, 10);
  return Number.isNaN(n) ? 0 : Math.max(0, n);
};
